"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var primitives_1 = require("../../primitives");
exports.default = primitives_1.color;
